export default __webpack_public_path__ + "static/media/icone-contato.84f28f7f.svg";